module.exports = __webpack_public_path__ + "img/Weapon_281.64c80f5c.png";